import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import TabNavigation from '../../components/ui/TabNavigation';
import AudioPlayerBar from '../../components/ui/AudioPlayerBar';
import SearchBar from './components/SearchBar';
import FilterPanel from './components/FilterPanel';
import TrendingSection from './components/TrendingSection';
import FeaturedVoices from './components/FeaturedVoices';
import ResultsGrid from './components/ResultsGrid';

const SearchAndDiscovery = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({
    contentType: 'all',
    duration: 'all',
    language: 'ru',
    topics: []
  });
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentAudio, setCurrentAudio] = useState(null);

  const mockSearchResults = [
  {
    id: 1,
    title: 'Медитация на рассвете: Практика осознанности',
    hostName: 'Анна Медитация',
    hostAvatar: "https://images.unsplash.com/photo-1699594550911-9a2eab4a614d",
    hostAvatarAlt: 'Профессиональное фото женщины с длинными темными волосами в белой одежде на фоне природы',
    artwork: "https://images.unsplash.com/photo-1676666372076-8159112de234",
    artworkAlt: 'Спокойная сцена восхода солнца над океаном с медитирующим силуэтом на берегу',
    duration: 45,
    listeners: 2340,
    rating: 4.8,
    date: '02.12.2025',
    isLive: false,
    isSaved: false,
    topics: ['Медитация', 'Осознанность', 'Утро']
  },
  {
    id: 2,
    title: 'Философия свободы: Беседа о выборе',
    hostName: 'Дмитрий Философ',
    hostAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13f4b3d4d-1763295780084.png",
    hostAvatarAlt: 'Портрет мужчины средних лет с бородой в очках на нейтральном фоне',
    artwork: "https://images.unsplash.com/photo-1537214324314-865a6766ac5f",
    artworkAlt: 'Открытая книга философии на деревянном столе с чашкой кофе и очками',
    duration: 72,
    listeners: 1890,
    rating: 4.9,
    date: '01.12.2025',
    isLive: true,
    isSaved: true,
    topics: ['Философия', 'Свобода', 'Выбор']
  },
  {
    id: 3,
    title: 'Путешествие по островам Таиланда',
    hostName: 'Мария Путешественница',
    hostAvatar: "https://images.unsplash.com/photo-1651932043410-c4e41f68044d",
    hostAvatarAlt: 'Фото молодой женщины с рюкзаком на фоне гор и неба',
    artwork: "https://images.unsplash.com/photo-1549820406-713e1c88d95b",
    artworkAlt: 'Тропический пляж с белым песком, пальмами и бирюзовой водой в Таиланде',
    duration: 38,
    listeners: 3120,
    rating: 4.7,
    date: '30.11.2025',
    isLive: false,
    isSaved: false,
    topics: ['Путешествия', 'Таиланд', 'Острова']
  },
  {
    id: 4,
    title: 'Джазовый вечер: Импровизация и свобода',
    hostName: 'Алексей Музыкант',
    hostAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d1b8c56a-1764681264026.png",
    hostAvatarAlt: 'Портрет молодого мужчины с саксофоном в студии звукозаписи',
    artwork: "https://img.rocket.new/generatedImages/rocket_gen_img_1853b201d-1764676738075.png",
    artworkAlt: 'Джазовый музыкант играет на саксофоне в темном клубе с мягким освещением',
    duration: 90,
    listeners: 1560,
    rating: 4.6,
    date: '29.11.2025',
    isLive: false,
    isSaved: true,
    topics: ['Музыка', 'Джаз', 'Импровизация']
  },
  {
    id: 5,
    title: 'Искусство современности: Диалог с художником',
    hostName: 'Елена Культура',
    hostAvatar: "https://images.unsplash.com/photo-1585077888877-6608b48b59be",
    hostAvatarAlt: 'Профессиональное фото женщины в художественной студии с картинами на фоне',
    artwork: "https://images.unsplash.com/photo-1667470928088-57bfc3f28cf8",
    artworkAlt: 'Современная художественная галерея с абстрактными картинами на белых стенах',
    duration: 55,
    listeners: 980,
    rating: 4.5,
    date: '28.11.2025',
    isLive: false,
    isSaved: false,
    topics: ['Культура', 'Искусство', 'Современность']
  },
  {
    id: 6,
    title: 'Наука о сознании: Новые открытия',
    hostName: 'Игорь Ученый',
    hostAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c74b2d51-1763294866887.png",
    hostAvatarAlt: 'Портрет мужчины в белом лабораторном халате в научной лаборатории',
    artwork: "https://img.rocket.new/generatedImages/rocket_gen_img_1214a648f-1764663624058.png",
    artworkAlt: 'Научная лаборатория с микроскопом и исследовательским оборудованием',
    duration: 65,
    listeners: 1240,
    rating: 4.8,
    date: '27.11.2025',
    isLive: false,
    isSaved: false,
    topics: ['Наука', 'Сознание', 'Исследования']
  }];


  useEffect(() => {
    setSearchResults(mockSearchResults);
  }, []);

  const handleSearch = (query) => {
    setSearchQuery(query);
    setIsLoading(true);

    setTimeout(() => {
      let filtered = mockSearchResults?.filter((result) =>
      result?.title?.toLowerCase()?.includes(query?.toLowerCase()) ||
      result?.hostName?.toLowerCase()?.includes(query?.toLowerCase()) ||
      result?.topics?.some((topic) => topic?.toLowerCase()?.includes(query?.toLowerCase()))
      );
      setSearchResults(filtered);
      setIsLoading(false);
    }, 800);
  };

  const handleVoiceSearch = (query) => {
    handleSearch(query);
  };

  const handleFilterChange = (newFilters) => {
    if (newFilters?.reset) {
      setFilters({
        contentType: 'all',
        duration: 'all',
        language: 'ru',
        topics: []
      });
      setSearchResults(mockSearchResults);
      return;
    }

    setFilters((prev) => ({ ...prev, ...newFilters }));
    setIsLoading(true);

    setTimeout(() => {
      let filtered = [...mockSearchResults];

      if (newFilters?.contentType && newFilters?.contentType !== 'all') {
        filtered = filtered?.filter((result) => {
          if (newFilters?.contentType === 'live') return result?.isLive;
          if (newFilters?.contentType === 'recorded') return !result?.isLive;
          return true;
        });
      }

      if (newFilters?.duration && newFilters?.duration !== 'all') {
        filtered = filtered?.filter((result) => {
          if (newFilters?.duration === 'short') return result?.duration <= 15;
          if (newFilters?.duration === 'medium') return result?.duration > 15 && result?.duration <= 60;
          if (newFilters?.duration === 'long') return result?.duration > 60;
          return true;
        });
      }

      if (newFilters?.topics && newFilters?.topics?.length > 0) {
        filtered = filtered?.filter((result) =>
        result?.topics?.some((topic) =>
        newFilters?.topics?.some((filterTopic) =>
        topic?.toLowerCase()?.includes(filterTopic?.toLowerCase())
        )
        )
        );
      }

      setSearchResults(filtered);
      setIsLoading(false);
    }, 500);
  };

  const handlePlay = (content) => {
    setCurrentAudio({
      url: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
      title: content?.title,
      artist: content?.hostName,
      artwork: content?.artwork
    });
  };

  const handleSave = (contentId, isSaved) => {
    setSearchResults((prev) =>
    prev?.map((result) =>
    result?.id === contentId ? { ...result, isSaved } : result
    )
    );
  };

  const handleTopicClick = (topicName) => {
    handleSearch(topicName);
  };

  const handleFollow = (hostId, isFollowing) => {
    console.log(`Host ${hostId} ${isFollowing ? 'followed' : 'unfollowed'}`);
  };

  return (
    <>
      <Helmet>
        <title>Поиск и Открытия - Radio Co Im</title>
        <meta
          name="description"
          content="Исследуйте разнообразный аудиоконтент на Radio Co Im. Найдите эфиры, голоса и темы, которые резонируют с вашей душой." />

      </Helmet>
      <div className="search-discovery-page min-h-screen bg-background">
        <TabNavigation />
        
        <main className="page-content max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:pr-[336px]">
          <div className="page-header mb-8">
            <h1 className="text-3xl font-heading font-bold text-foreground mb-2">
              Поиск и Открытия
            </h1>
            <p className="text-muted-foreground">
              Найдите аутентичные голоса и контент, который резонирует с вами
            </p>
          </div>

          <div className="search-section mb-8">
            <SearchBar
              onSearch={handleSearch}
              onVoiceSearch={handleVoiceSearch} />

          </div>

          <div className="content-layout grid grid-cols-1 lg:grid-cols-4 gap-6">
            <aside className="filters-sidebar lg:col-span-1">
              <FilterPanel
                onFilterChange={handleFilterChange}
                resultCount={searchResults?.length} />

              
              <div className="mt-6">
                <TrendingSection onTopicClick={handleTopicClick} />
              </div>
            </aside>

            <div className="main-content lg:col-span-3 space-y-8">
              {!searchQuery &&
              <FeaturedVoices onFollow={handleFollow} />
              }

              <ResultsGrid
                results={searchResults}
                onPlay={handlePlay}
                onSave={handleSave}
                isLoading={isLoading} />

            </div>
          </div>
        </main>

        <AudioPlayerBar
          audioSource={currentAudio}
          initialPlaybackState="paused"
          onPlayPause={(state) => console.log('Playback state:', state)}
          onSeek={(time) => console.log('Seek to:', time)}
          onVolumeChange={(volume) => console.log('Volume:', volume)}
          onNext={() => console.log('Next track')}
          onPrevious={() => console.log('Previous track')} />

      </div>
    </>);

};

export default SearchAndDiscovery;